module.exports = __webpack_public_path__ + "static/media/stanley.0e45fbde.svg";